/**
 * @generated SignedSource<<eb1372f74ffa96d2a20fd2c01128a950>>
 * @relayHash 2942d1650ba991c2cfe825838bb09319
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 390b051f0768c6a8862f2c8003fce33df83d67fab87c2abde50e5be497ec94b7

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type GrowthUnifiedProfileTrialTrigger = "AUTO_UPGRADE_USER_LIMIT" | "CROSSFLOW_USER_LIMIT" | "EDITION_PARITY" | "REACTIVATION" | "REVERSE_TRIAL" | "UI" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  inPreDunning?: boolean | null | undefined;
  inTrialOrPreDunning?: boolean | null | undefined;
};
export type editionAwarenessQuery$variables = {
  accountId: string;
  applicationKey: JiraApplicationKey;
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null | undefined;
  onboardingStateKeys: ReadonlyArray<string>;
  productKey: string;
  shouldCheckBillingAdmin: boolean;
  shouldCheckForChangeOffering: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForCollection: boolean;
  shouldCheckForDirectBuyChangeOffering: boolean;
  shouldCheckForPaymentDetails: boolean;
  shouldCheckForStorageLimit: boolean;
  shouldCheckForStorageUsageConfluence: boolean;
  shouldCheckForStorageUsageJira: boolean;
  shouldCheckForTrial: boolean;
  shouldCheckForUserEmail: boolean;
  shouldCheckHasSeenModal: boolean;
  shouldIncludeProfile: boolean;
  shouldSkip: boolean;
};
export type editionAwarenessQuery$data = {
  readonly confluence_storage?: {
    readonly bytesUsed: AGG$Long;
  } | null | undefined;
  readonly jira?: {
    readonly attachmentStorageAllowed?: AGG$Long | null | undefined;
    readonly attachmentStorageIsUnlimited?: boolean | null | undefined;
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly __typename: string;
        readonly entitlementProfile?: {
          readonly lastKnownTrial: {
            readonly createdAt: number | null | undefined;
            readonly trialEndTimeStamp: number | null | undefined;
            readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null | undefined;
            readonly trialType: GrowthUnifiedProfileTrialType | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly experienceCapabilities?: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
          readonly changeOfferingV2WithSkipTrial?: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly latestUsageForChargeElement?: number | null | undefined;
        readonly offering?: {
          readonly trial: {
            readonly lengthDays: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null | undefined;
        } | null | undefined;
        readonly relatesFromEntitlements?: ReadonlyArray<{
          readonly entitlementId: string | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null | undefined;
                  readonly isAvailableToUser: boolean | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly trial: {
            readonly endTimestamp: number | null | undefined;
            readonly startTimestamp: number | null | undefined;
            readonly timeLeft: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount?: {
          readonly isBillToPresent?: boolean | null | undefined;
          readonly isCurrentUserBillingAdmin: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly user?: {
    readonly email?: string | null | undefined;
  } | null | undefined;
  readonly userPreferences?: {
    readonly onboardingState: ReadonlyArray<{
      readonly key: string;
      readonly value: string | null | undefined;
    }>;
  } | null | undefined;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onboardingStateKeys"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckBillingAdmin"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChangeOffering"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForCollection"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForDirectBuyChangeOffering"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForPaymentDetails"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageLimit"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageConfluence"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageJira"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForUserEmail"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckHasSeenModal"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldIncludeProfile"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkip"
},
v21 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v22 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "applicationKey"
  },
  (v21/*: any*/)
],
v23 = {
  "condition": "shouldCheckForStorageUsageJira",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "shouldCheckForStorageLimit",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v22/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageAllowed"
            },
            {
              "args": (v22/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageIsUnlimited"
            }
          ]
        },
        {
          "args": (v22/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        }
      ]
    }
  ]
},
v24 = {
  "condition": "shouldCheckForStorageUsageConfluence",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        (v21/*: any*/)
      ],
      "concreteType": "ConfluenceStorage",
      "kind": "LinkedField",
      "name": "confluence_storage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "bytesUsed"
        }
      ]
    }
  ]
},
v25 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v26 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v27 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v28 = {
  "kind": "ScalarField",
  "name": "id"
},
v29 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v30 = {
  "kind": "Literal",
  "name": "offeringName",
  "value": "Standard"
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v33 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v34 = [
  (v32/*: any*/),
  (v33/*: any*/)
],
v35 = {
  "condition": "shouldCheckForDirectBuyChangeOffering",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "changeOfferingV2WithSkipTrial",
          "args": [
            (v30/*: any*/),
            {
              "kind": "Literal",
              "name": "skipTrial",
              "value": true
            }
          ],
          "concreteType": "CcpChangeOfferingExperienceCapability",
          "kind": "LinkedField",
          "name": "changeOfferingV2",
          "plural": false,
          "selections": (v34/*: any*/),
          "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
        }
      ],
      "type": "CcpEntitlementExperienceCapabilities"
    }
  ]
},
v36 = {
  "condition": "shouldCheckForChargeQuantities",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "chargeElement",
          "variableName": "chargeElement"
        }
      ],
      "kind": "ScalarField",
      "name": "latestUsageForChargeElement"
    }
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "status"
},
v38 = {
  "kind": "ScalarField",
  "name": "timeLeft"
},
v39 = {
  "kind": "ScalarField",
  "name": "startTimestamp"
},
v40 = {
  "kind": "ScalarField",
  "name": "endTimestamp"
},
v41 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v42 = {
  "kind": "ScalarField",
  "name": "lengthDays"
},
v43 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v44 = {
  "kind": "ScalarField",
  "name": "isBillToPresent"
},
v45 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v46 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v47 = {
  "condition": "shouldIncludeProfile",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
      "kind": "LinkedField",
      "name": "entitlementProfile",
      "plural": false,
      "selections": [
        {
          "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
          "kind": "LinkedField",
          "name": "lastKnownTrial",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "trialType"
            },
            {
              "kind": "ScalarField",
              "name": "trialTrigger"
            },
            {
              "kind": "ScalarField",
              "name": "trialEndTimeStamp"
            },
            {
              "kind": "ScalarField",
              "name": "createdAt"
            }
          ]
        }
      ]
    }
  ]
},
v48 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v49 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "email"
    }
  ],
  "type": "AtlassianAccountUser"
},
v50 = {
  "condition": "shouldCheckHasSeenModal",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "key",
              "variableName": "onboardingStateKeys"
            }
          ],
          "concreteType": "UserOnboardingState",
          "kind": "LinkedField",
          "name": "onboardingState",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ]
},
v51 = [
  (v28/*: any*/)
],
v52 = {
  "kind": "InlineFragment",
  "selections": (v51/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      (v23/*: any*/),
      (v24/*: any*/),
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v25/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v26/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  {
                    "args": (v27/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      (v29/*: any*/),
                      {
                        "condition": "shouldCheckForChangeOffering",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                              {
                                "args": (v31/*: any*/),
                                "kind": "LinkedField",
                                "name": "changeOfferingV2",
                                "plural": false,
                                "selections": (v34/*: any*/),
                                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                              },
                              (v35/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v36/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "preDunning",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v41/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v33/*: any*/),
                                              (v32/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckBillingAdmin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v43/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForPaymentDetails",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForCollection",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              (v45/*: any*/),
                              (v46/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v47/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForUserEmail",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v48/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v49/*: any*/)
            ]
          }
        ]
      },
      (v50/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v11/*: any*/),
      (v16/*: any*/),
      (v20/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v10/*: any*/),
      (v15/*: any*/),
      (v1/*: any*/),
      (v14/*: any*/),
      (v0/*: any*/),
      (v17/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      (v19/*: any*/),
      (v18/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      (v23/*: any*/),
      (v24/*: any*/),
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v25/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v26/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  {
                    "args": (v27/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      (v29/*: any*/),
                      {
                        "condition": "shouldCheckForChangeOffering",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              {
                                "args": (v31/*: any*/),
                                "kind": "LinkedField",
                                "name": "changeOfferingV2",
                                "plural": false,
                                "selections": [
                                  (v29/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                              },
                              (v35/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v36/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "preDunning",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v37/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v29/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  (v29/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v41/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v29/*: any*/),
                                              (v33/*: any*/),
                                              (v32/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v51/*: any*/),
                                        "type": "CcpInvoiceGroup"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v51/*: any*/),
                                "type": "CcpSubscription"
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v29/*: any*/),
                                  (v42/*: any*/)
                                ]
                              },
                              (v52/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckBillingAdmin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v43/*: any*/),
                              (v52/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForPaymentDetails",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v44/*: any*/),
                              (v52/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForCollection",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              (v29/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v47/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForUserEmail",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v48/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              (v49/*: any*/),
              (v28/*: any*/)
            ]
          }
        ]
      },
      (v50/*: any*/)
    ]
  },
  "params": {
    "id": "390b051f0768c6a8862f2c8003fce33df83d67fab87c2abde50e5be497ec94b7",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8ea7a6a37be98e9cb51f43610ce76ae1";

export default node;
